// router内懒加载路由
export const requireComponent = (path) => {
  return () => import('@/views/' + path)
}
export const getCheckArr = (data) => {
  const regExpArr = /\[*?\]/gi // 是否为数组字符串
  const regExpRE = /\^*?\$\)\+/gi // 是否为字符串
  // const matchReg = /(?<=\^).*?(?=\$\)\+)/ // 字符串截取
  // 根据判断返回值是否为Array进行后续任务
  try {
    return regExpArr.test(data) ? JSON.parse(data) : (regExpRE.test(data) ? data.slice(2).slice(0, -3).split('$|^').map(item => {
      return {
        label: item, value: item
      }
    })
      : {
        message: data
      })
  } catch (e) {
    return {
      message: data
    }
  }
}

// 判断当前客户端系统
export const detectOS = () => {
  const isWin = (navigator.platform == 'Win32') || (navigator.platform == 'Windows')
  const isMac = (navigator.platform == 'Mac68K') || (navigator.platform == 'MacPPC') || (navigator.platform == 'Macintosh') || (navigator.platform == 'MacIntel')
  if (isMac) return 'mac'
  if (isWin) return 'win'
  return 'other'
}
